import { render, staticRenderFns } from "./RulesAndRegulations.vue?vue&type=template&id=b8eddce4"
import script from "./RulesAndRegulations.vue?vue&type=script&lang=js"
export * from "./RulesAndRegulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports